export const PortalStates = {
    SUCCESS: 'PORTAL_SUCCESS',
    FAILED: 'PORTAL_FAILED',
    RESET: 'PORTAL_RESET',
    DELETE: 'PORTAL_RESET',
};
